import { useMemo } from 'react';

import type { Holding } from '@/hooks/portfolio/usePortfolio';

export const useHoldingsLimits = <T extends Holding>({
  portfolioHoldings,
}: {
  portfolioHoldings: T[];
}) =>
  useMemo(() => {
    const { holdings, excludedHoldings } = portfolioHoldings.reduce<{
      holdings: T[];
      excludedHoldings: T[];
    }>(
      (acc, holding) => {
        if (holding.isAnalysisRestricted === true) {
          acc.excludedHoldings.push(holding);
        } else {
          acc.holdings.push(holding);
        }
        return acc;
      },
      { holdings: [], excludedHoldings: [] }
    );

    return { holdings, excludedHoldings };
  }, [portfolioHoldings]);
